import { AnimatePresence, motion } from 'motion/react'

const AnimatedContent = ({ children, direction, currentRoute }) => {
  const variantsAnimation = {
    initial: {
      opacity: 0,
      x: direction < 0 ? -100 : 100,
    },
    animate: {
      opacity: 1,
      x: 0,
    },
  }

  const transitionsAnimation = {
    type: 'spring',
    bounce: 0.4,
    duration: 0.3,
  }

  return (
    <AnimatePresence>
      <motion.div
        key={currentRoute}
        initial="initial"
        animate="animate"
        exit="initial"
        variants={variantsAnimation}
        transition={transitionsAnimation}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  )
}

export default AnimatedContent
